import Login from '@/views/operator/login'
import ApplicationForSettlement from '@/views/operator/application-for-settlement'

export const routers = [
  {
    path: 'login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: Login
  },
  {
    path: 'apply',
    name: 'application-for-settlement',
    meta: {
      title: '商户申请入驻'
    },
    component: ApplicationForSettlement
  }
]